module.exports = "/_next/static/images/goldenburger_top-0edc0ccbb47f6f61c5679f94b66454fb.jpg";